import React from "react";
import "./ContactCTA.scss";

export default function ContactCTA() {
  return (
    <section className="contact-cta" aria-labelledby="ccta-title">
      <div className="contact-cta__bar">
        <h3 id="ccta-title" className="ccta__title">Still have questions?</h3>

        {/* Uses your global .btn styles; <a> avoids router deps */}
        <a className="btn btn-primary ccta__button" href="/contact-us">
          Contact us
        </a>
      </div>
    </section>
  );
}
